import axios from 'axios'
import config from '../config'
import { getPatientToken } from '../utils'

const getAppointmentDetailsApi = async(params) => {
    const response = await axios({
        url: `${config.api.base_url}book-appointment/${params.id}`,
        method: "get",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${getPatientToken()}`
        }
    })
    return response
}

export default getAppointmentDetailsApi